module.exports = __webpack_public_path__ + "img/trip_sendai08.63813ea4.jpg";